(function($) {
    $(document).ready(function(){
        $('.dropdown-menu > li > .dropdown-menu').parent().addClass('dropdown-submenu').find(' > .dropdown-item').addClass('dropdown-toggle');
        $('.dropdown-submenu > a').on("click", function(e) {
        var dropdown = $(this).parent().find(' > .show');
            $('.dropdown-submenu .dropdown-menu').not(dropdown).removeClass('show');
            $(this).next('.dropdown-menu').toggleClass('show');
            e.stopPropagation();
        });
        $('.dropdown').on("hidden.bs.dropdown", function() {
            $('.dropdown-menu.show').removeClass('show');
        });
    });

    // Remove Link from Menu on Mobile
            
        if ($(window).width() < 992) {
            $('.dropdown-toggle, .menu-item-has-children > a.dropdown-item').addClass('no-link').attr('href', '#');
            $( document ).on( 'click', '.no-link', function( e ){
                e.preventDefault();
            } );
            

        $(".dropdown-toggle").attr('data-toggle', 'dropdown-submenu');
        }


    // DropDown Menu Animation
    $('.dropdown').on('show.bs.dropdown', function(e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
    });

    $('.dropdown').on('hide.bs.dropdown', function(e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
    });
})(jQuery);